import { ListTemplates } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";
export const GetAllBMSPDFs = {
  data() {
    return {
      overlay: false,
      noDataText: "",
      GetAllBMSPDFsList: [],
    };
  },
  methods: {
    async GetAllBMSPDFsMethod() {
      try {
        this.overlay = true;
        let result = await API.graphql(
          graphqlOperation(ListTemplates, {
            input: {},
          })
        );
        this.GetAllBMSPDFsList = JSON.parse(
          result.data.ListTemplates
        ).data.items;
        this.overlay = false;
      } catch (error) {
        this.overlay = false;
        this.GetAllBMSPDFsList = [];
        this.noDataText = error.errors[0].message;
      }
    },
  },
};
